import {
	BlockControls,
	RichText,
	useBlockProps,
} from "@wordpress/block-editor";
import { createBlock } from "@wordpress/blocks";
import { Button, ToolbarGroup } from "@wordpress/components";
import { dispatch, select, useSelect } from "@wordpress/data";
import { __ } from "@wordpress/i18n";
import React from "react";
import * as selectors from "wordpress__block-editor/store/selectors";
import IconRenderer from "../../components/common/IconRenderer";
import { useClientId, useCopyPasteStyles, useDeviceType } from "@blocks/hooks";
import {
	// useAnimation,
	useBlockStyle,
} from "../../hooks";
import { EditProps } from "../../types";
import { cn } from "../../utils";
import InspectorControls from "./components/InspectorControls";
import positionStyle from "./helpers/position-style";

const Edit: React.ComponentType<EditProps<any>> = (props) => {
	const {
		attributes: {
			text,
			style,
			size,
			icon,
			iconPosition,
			width,
			cssID,
			className,
			buttonAnimation,
			positionProperty,
			typography,
		},
		setAttributes,
		clientId: blockId,
	} = props;

	const { clientId } = useClientId(props);
	const { deviceType } = useDeviceType();
	const { CopyPasterStyleBlockControl } = useCopyPasteStyles();
	const { Style } = useBlockStyle({
		blockName: "button",
		clientId,
		attributes: props.attributes,
		deviceType,
	});
	// const { Animation } = useAnimation({
	// 	id: clientId,
	// 	type: buttonAnimation,
	// });

	const blockProps = useBlockProps({
		className: cn(`mzb-button mzb-button-${clientId}`, className),
	});

	const _positionStyle = positionStyle(positionProperty);

	const rootClientId = useSelect(
		(select) => {
			const { getBlockRootClientId } = select(
				"core/block-editor"
			) as typeof selectors;

			return getBlockRootClientId(props.clientId);
		},
		[props.clientId]
	) as string;

	const addRemoveBlock = (type: "add" | "delete") => {
		const { getBlockIndex, getBlocks } = select("core/block-editor");
		const { replaceInnerBlocks } = dispatch("core/block-editor");
		const selectedBlockIndex = getBlockIndex(props.clientId, rootClientId);
		const innerBlocks = [...getBlocks(rootClientId)];

		if (type === "delete") {
			innerBlocks.splice(selectedBlockIndex, 1);
		} else {
			innerBlocks.splice(
				selectedBlockIndex + 1,
				0,
				createBlock("magazine-blocks/button")
			);
		}

		replaceInnerBlocks(rootClientId as string, innerBlocks, false);
	};

	const widthStyle = width?.[deviceType];

	return (
		<>
			<InspectorControls
				attributes={props.attributes}
				setAttributes={setAttributes}
			/>
			{/* @ts-ignore */}
			{/* <BlockControls group="block">
				<ToolbarGroup>
					<Button
						label={__("Add button", "magazine-blocks")}
						onClick={() => addRemoveBlock("add")}
						icon="plus"
					/>
					<Button
						label={__("Delete button", "magazine-blocks")}
						onClick={() => addRemoveBlock("delete")}
						icon="trash"
					/>
				</ToolbarGroup>
			</BlockControls> */}
			<CopyPasterStyleBlockControl withBlockControls />
			<Style />
			{_positionStyle && (
				<style>{`[data-block="${blockId}"] { ${_positionStyle} }`}</style>
			)}
			{widthStyle && (
				<style>{`[data-aos-id="${clientId}"] { width: ${widthStyle}%;}`}</style>
			)}
			{/*<Animation>*/}
			<div {...blockProps} id={cssID}>
				<div
					className={cn(
						"mzb-button-link",
						size &&
							("filled" === style || "outline" === style) &&
							`is-${size}`,
						style && `is-style-${style}`,
						typography?._className
					)}
				>
					{icon &&
						"" !== icon.icon &&
						icon.enable &&
						"left" === iconPosition && (
							<span className="mzb-button-icon">
								<IconRenderer name={icon.icon} />
							</span>
						)}
					<RichText
						value={text}
						placeholder={__("Text Here…", "magazine-blocks")}
						onChange={(val) => {
							setAttributes({ text: val });
						}}
						allowedFormats={["core/bold", "core/italic"]}
					/>
					{icon &&
						"" !== icon.icon &&
						icon.enable &&
						"right" === iconPosition && (
							<span className="mzb-button-icon">
								<IconRenderer name={icon.icon} />
							</span>
						)}
				</div>
			</div>
			{/*</Animation>*/}
		</>
	);
};

export default Edit;
